import differenceInCalendarYears from "date-fns/difference_in_calendar_years";
import i18next from "i18next";
import {
    checkAndGetSessionStorageValue,
    generateJsonWebToken
} from "../../../features/utils.js";
import i18n from "../../../i18n";
import { commonConstant } from "../../../server/triage/constants";

export async function getRiskFactor({ typeOfRiskFactor }) {
    let riskFactor = null;
    if (localStorage.getItem('riskfactors') != null) {
        let riskfactors = JSON.parse(localStorage.getItem('riskfactors'));
        riskfactors.forEach(function (element) {
            if (element.id === typeOfRiskFactor) {
                riskFactor = element;
                return riskFactor;
            }
        });
    }
    return riskFactor;
}

export async function callRiskFactor({ actions, fields }) {
    const { year, month, day } = fields.birthdate;
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    var ageInYears;
    if (year === "" || month === "" || day === "") {
        ageInYears = commonConstant.age;
    } else {
        var birthDate = new Date(year, month - 1, day);
        ageInYears = differenceInCalendarYears(new Date(), birthDate);
    }

    var response = await actions.sendTriageRequest({
        action: "riskfactors",
        data: {
            Language: actions.getLanguage(i18n.language),
            age: ageInYears < 18 ? 19 : ageInYears,
            jwtAccessToken: jwtAccess_Token,
            accessToken: access_Token,
        },
    });
    if (response && response.message === commonConstant.success) {
        localStorage.setItem(
            "riskfactors",
            JSON.stringify(response.riskFactors)
        );
        return response;
    } else {
        return null;
    }
}

export async function GetRecentPhysicalInjuryRiskFactor({ actions }) {
    var riskFactorObj = {
        name: "",
        id: "",
    };
    let typeOfRiskFactor = await actions.getRiskFactor({
        typeOfRiskFactor: "p_264",
    });

    if (typeOfRiskFactor !== null) {
        riskFactorObj = {
            name: typeOfRiskFactor.common_name,
            id: typeOfRiskFactor.id,
        };
        return riskFactorObj;
    } else {
        return riskFactorObj;
    }
}

export async function GetChildbirthRiskFactor({ actions }) {
    {
        let typeOfRiskFactor = await actions.getRiskFactor({
            typeOfRiskFactor: "p_55",
        });
        return typeOfRiskFactor !== null ? typeOfRiskFactor.common_name : "";
    }
}

export async function CheckAndGetRiskFactorDetails(actions, fields, setFields) {
    await actions.callRiskFactor({ actions, fields });

    var recentPhysicalVal = await actions.GetRecentPhysicalInjuryRiskFactor({
        actions,
    });
    if (recentPhysicalVal.id === "p_264") {
        var translatedContent = i18next.t(
            "findcareoption.Start.recentPhysicalInjury"
        );
        setFields({
            riskFactorVal: translatedContent,
            isRiskFactorCompleted: true,
        });
    } else {
        setFields({
            riskFactorVal: "",
            isRiskFactorCompleted: true,
        });
    }
    var recentChildBirthVal = await actions.GetChildbirthRiskFactor({
        actions,
    });
    setFields({
        childBirthName: recentChildBirthVal,
        isRiskFactorCompleted: true,
    });
}
